export default {"src":"/_next/static/media/0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c.78d085d4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};